"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferencesContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const containerStyle = {
    padding: 10,
    backgroundColor: '#f1f1f1',
    height: '100%',
    overflowY: 'auto',
};
function PreferencesContainer({ children, style, }) {
    return (0, jsx_runtime_1.jsx)("div", { style: { ...containerStyle, ...style }, children: children });
}
exports.PreferencesContainer = PreferencesContainer;
